// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ecQ7","textarea":"styles_textarea__2xoyH"};